export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7428.3200b808.jpg";